import React, { useEffect, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';
import Iconify from '../common/iconify.component';
import Loading from '../table-elements/loading.component';
import SnackbarInfo from '../common/snackbar-info.component';
import ViewData from '../table-elements/view-data.component';
import { viewVideoById } from '../../services/content.service';
import { VIEW_VIDEOS_COLUMNS, VIEW_PODCAST_COLUMNS, VIEW_EPISODE_COLUMNS } from '../../config/module-configs/videos.config';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ViewVideos = ({
  title,
  dataId,
  onCancel,
  type,
}) => {
  let columns = VIEW_VIDEOS_COLUMNS;  
  if (type === 'EPISODE')
  {
    columns = VIEW_EPISODE_COLUMNS;  
  }
  else if (type === 'PODCAST') {
    columns = VIEW_PODCAST_COLUMNS;  
  }

  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState(null);
  const [snackbarInfo, setSnackbarInfo] = useState({
    show: false,
    type: '',
    message: '',
  });
  const renderColumns = columns;
  useEffect(() => {
    viewVideoById(dataId)
      .then((res) => {
        const response = res.data;
        if (response.contentType === "MOVIE") {
           const categoryName = response.categories.map((item, i) => {
           const catData = `${item.title}`;

            return response.categories.length === i + 1 ? catData : `${catData}, `;
          });
          if (categoryName) {
            response.categoryName = categoryName;
          }
        }
        setRowData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          'Something went wrong, please try again.';

        setSnackbarInfo({
          ...snackbarInfo,
          show: true,
          type: 'error',
          message,
        });
        setLoading(false);
      });
  }, [dataId]);

  return (
    <Dialog
      open
      onClose={() => onCancel()}
      aria-labelledby="view-dialog-title"
      aria-describedby="view-dialog-description"
      TransitionComponent={Transition}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle id="view-dialog-title">{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCancel}
        size="small"
        sx={{
          position: 'absolute',
          right: 10,
          top: 15,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Iconify icon="ic:outline-close" />
      </IconButton>

      <DialogContent dividers id="view-dialog-description">
        {loading && <Loading />}

        {!loading && <ViewData columns={renderColumns} row={rowData} />}
      </DialogContent>

      {snackbarInfo.show && (
        <SnackbarInfo type={snackbarInfo.type} message={snackbarInfo.message} />
      )}
    </Dialog>
  );
};

ViewVideos.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  dataId: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ViewVideos;
